import React from 'react'
import { Button, Toast, Dialog } from 'react-weui'
import axios from 'axios'
import { browserHistory } from 'react-router'
import { WKVisible, WKOwnDialog } from '../../components/wk'
import topBgImg from '../../images/liveroom/liveroom-app-top-bg.png'
import icImg from '../../images/liveroom/liveroom-app-ic.png'
import vipYellowImg from '../../images/liveroom/vip-yellow.png'
import vipBlueImg from '../../images/liveroom/vip-blue.png'


class LiveroomAppPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            liveroom: {},
            role: {},
            stats_info: {},
            isFans: false,
            isPending: false,
            isShowUnfollowDialog: false,
            isShowFollowSuccessToast: false,
            isLiveroomInfoFetchDone: false,
        }
    }
    componentDidMount () {
        this.fetchInfo()
    }
    fetchInfo () {
        const id = this.props.params.liveroom_id
        axios.get(`/api/liveroom/${id}/info`)
            .then(res => {
                const data = res.data.data
                this.setState({
                    liveroom: data.liveroom,
                    role: data.role,
                    stats_info: data.stats_info,
                    isFans: data.role.is_fans,
                    isLiveroomInfoFetchDone: true,
                })
            })
    }
    getLongNum (num) {
        if (num < 1e4) {
            return num
        } else {
            return `${+(num / 1e4).toFixed(2)}万+`
        }
    }
    onClickEdit (id) {
        location.assign(`/liveroom/${id}/edit/profile?from=liveroom_app`)
    }
    onClickFollow (id) {
        this.setState({ isPending: true })
        axios.post(`/api/liveroom/${id}/follow`)
            .then(res => {
                this.setState({
                    isPending: false,
                    isFans: !this.state.isFans,
                })
                this.showFollowSuccessToast()
            })
    }
    onClickUnfollow (id) {
        this.setState({ isShowUnfollowDialog: true })
    }
    onClickUnfollowDialogOk (id) {
        this.setState({ isShowUnfollowDialog: false })
        this.setState({ isPending: true })
        axios.post(`/api/liveroom/${id}/unfollow`)
            .then(res => {
                this.setState({
                    isPending: false,
                    isFans: !this.state.isFans,
                })
            })
    }
    onClickUnfollowDialogCancle () {
        this.setState({ isShowUnfollowDialog: false })
    }
    showFollowSuccessToast () {
        this.setState({ isShowFollowSuccessToast: true })
        setTimeout(() => {
            this.setState({ isShowFollowSuccessToast: false })
        }, 2000)
    }
    // 认证图标图标展示
    verifyIconRen = () => {
        const htmlObj = {
            1: <img className='vip-img' src="https://static-cos.lycheer.net/xupload/20220725_vip-yellow.png" />,
            2: <img className='vip-img' src="https://static-cos.lycheer.net/xupload/20220725_vip-blue.png" />,
        }
        if(this.state.liveroom.is_government === 1) {
            return <img className='vip-img' src="https://static-cos.lycheer.net/xupload/20220725_vip-red.png" />
        }
        return htmlObj[this.state.liveroom.verify_type] || ''
    }
    render() {
        const { liveroom, stats_info, role, isFans, isLiveroomInfoFetchDone } = this.state
        return (
            <div className="liveroom-app-page wk-page">
                <div className="top-bg" style={{backgroundImage: `url(${topBgImg})`}}>
                </div>
                <div className="info-panel">
                    <div className="avatar">
                        <WKVisible show={isLiveroomInfoFetchDone}>
                            <img className='avatar-img' src={liveroom.avatar_url} alt="avatar"/>
                        </WKVisible>
                        {this.verifyIconRen()}
                    </div>
                    <div className="content">
                        <div className="title text-ellipsis">{liveroom.name || '-'}</div>
                        <div className="ip_address_desc_ver">
                            <div className="ip_address_con-desc">
                                { !!liveroom.verify_desc && (
                                    <div className="ip_address_con">
                                    <img src="https://static-cos.lycheer.net/xupload/20220724_ico-attestation.png" alt="" />
                                    <span className="verify_desc">{liveroom.verify_desc}</span>
                                    </div>
                                    )
                                }
                                { !!liveroom.ip_address && 
                                    (<div className="ip_address_con">
                                        <img src="https://static-cos.lycheer.net/xupload/20220718_ico-ip.png" alt="" />
                                        <span>IP属地：{liveroom.ip_address || ''}</span>
                                    </div>)
                                }
                            </div>
                        </div>
                        <div className="value">
                            <div className="value-item">
                                <p>关注</p>
                                <p className='green'>{stats_info.fans_count || 0}</p>
                            </div>
                            <div className="value-item">
                                <p>人气</p>
                                <p className='green'>{this.getLongNum(stats_info.popular || 0)}</p>
                            </div>
                        </div>
                        <div className='follow-btn-wrap' style={{opacity: isLiveroomInfoFetchDone ? 1 : 0}}>
                            <WKVisible create={role.is_manager}>
                                <Button className='green' onClick={e => this.onClickEdit(liveroom.id)}>编辑</Button>
                            </WKVisible>
                            <WKVisible create={!role.is_manager && !isFans}>
                                <Button onClick={e => this.onClickFollow(liveroom.id)}>+关注</Button>
                            </WKVisible>
                            <WKVisible create={!role.is_manager && isFans}>
                                <Button className='disabled' onClick={e => this.onClickUnfollow(liveroom.id)}><span>已关注</span></Button>
                            </WKVisible>
                        </div>
                    </div>
                </div>
                <div className="desc-wrap">
                    <div className="title">
                        <img src={icImg} alt=""/>
                        <div className="text">直播间介绍</div>
                        <img src={icImg} alt=""/>
                    </div>
                    <WKVisible create={liveroom.description}>
                        <div className="desc">
                            <pre>{liveroom.description}</pre>
                        </div>
                    </WKVisible>
                    <WKVisible create={!liveroom.description}>
                        <WKVisible create={role.is_manager}>
                            <div className="desc text-center">
                                撰写直播间介绍，让学员快速了解你。
                            </div>
                        </WKVisible>
                        <WKVisible create={!role.is_manager}>
                            <div className="desc text-center">
                                该直播间尚未留下任何介绍。
                            </div>
                        </WKVisible>
                    </WKVisible>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <WKOwnDialog show={this.state.isShowUnfollowDialog} type="ios"
                    title='确认取消关注？'
                    buttons={[{
                        label: '取消',
                        type: 'default',
                        onClick: () => this.onClickUnfollowDialogCancle()
                    }, {
                        label: '确认',
                        onClick: () => this.onClickUnfollowDialogOk(liveroom.id)
                    }]}
                >
                    取消关注将无法收到本直播间的新课和专栏通知
                </WKOwnDialog>
                <WKVisible show={this.state.isShowFollowSuccessToast}>
                    <div className="follow-toast">
                        <p>已关注本直播间，后续将收到新课通知</p>
                    </div>
                </WKVisible>
            </div>
        )
    }
}

export default LiveroomAppPage


// WEBPACK FOOTER //
// ./src/pages/liveroom/LiveroomAppPage.js